import { createVideo, getVideo, getVideos, updateVideo, deleteVideo } from '../../api/videos'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { Cookies } from 'react-cookie'
import toast from 'react-hot-toast'

// const isDev = process.env.NODE_ENV === 'development'

const initialState = {
  loading: false,
  error: null,
  videos: [],
  videoItem: null,
  count: 0,
}

export const getVideosReq = createAsyncThunk('getVideos', async (data, { rejectWithValue }) => {
  try {
    const res = await getVideos(data.id, data.skip, data.take)
    return res
  } catch (err) {
    toast.error(err.response.data.message)
    return rejectWithValue({ err: err.response.data })
  }
})
export const getVideoReq = createAsyncThunk('getVideo', async (data, { rejectWithValue }) => {
  try {
    const res = await getVideo(data.id)
    return res
  } catch (err) {
    toast.error(err.response.data.message)
    return rejectWithValue({ err: err.response.data })
  }
})
export const deleteVideoReq = createAsyncThunk('deleteVideo', async (data, { rejectWithValue }) => {
  try {
    const res = await deleteVideo(data.id)
    return res
  } catch (err) {
    toast.error(err.response.data.message)
    return rejectWithValue({ err: err.response.data })
  }
})
export const updateVideoReq = createAsyncThunk('updateVideo', async (data, { rejectWithValue }) => {
  const { id, ...rest } = data
  try {
    const res = await updateVideo(id, rest)
    return res
  } catch (err) {
    toast.error(err.response.data.message)
    return rejectWithValue({ err: err.response.data })
  }
})
export const createVideoReq = createAsyncThunk('createVideo', async (data, { rejectWithValue }) => {
  const { id, ...rest } = data
  try {
    const res = await createVideo(id, rest)
    return res
  } catch (err) {
    toast.error(err.response.data.message)
    return rejectWithValue({ err: err.response.data })
  }
})

export const videosSlice = createSlice({
  name: 'videos',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVideosReq.pending, (state, action) => {
        state.loading = true
        state.error = null
      })
      .addCase(getVideosReq.fulfilled, (state, action) => {
        state.loading = false
        state.videos = action.payload.videos
        state.count = action.payload.count
      })
      .addCase(getVideosReq.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(getVideoReq.pending, (state, action) => {
        state.loading = true
        state.error = null
      })
      .addCase(getVideoReq.fulfilled, (state, action) => {
        state.loading = false
        state.videoItem = action.payload
      })
      .addCase(getVideoReq.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(updateVideoReq.pending, (state, action) => {
        state.loading = true
        state.error = null
      })
      .addCase(updateVideoReq.fulfilled, (state, action) => {
        state.loading = false
        const index = state.videos.findIndex((obj) => obj.id === action.payload.id)

        if (index !== -1) {
          state.videos[index] = action.payload
        }
      })
      .addCase(updateVideoReq.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(createVideoReq.pending, (state, action) => {
        state.loading = true
        state.error = null
      })
      .addCase(createVideoReq.fulfilled, (state, action) => {
        state.loading = false
        state.videos = [...state.videos, action.payload]
      })
      .addCase(createVideoReq.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(deleteVideoReq.pending, (state, action) => {
        state.loading = true
        state.error = null
      })
      .addCase(deleteVideoReq.fulfilled, (state, action) => {
        state.loading = false
        state.videos = state.videos.filter((obj) => obj.id !== action.payload.id)
      })
      .addCase(deleteVideoReq.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

// export const { } = videosSlice.actions

export default videosSlice.reducer
